import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import Close from "@irati/ui/src/Close"

export const BannerWrapper = styled(Flex)`
  ${({theme}) => css`
    border: 2px dashed ${theme.colors.primary2_50};
    border-radius: ${theme.spacing.one};
    justify-content: space-between;
    margin: ${theme.spacing.four} 0;
    padding: ${theme.spacing.three};
    position: relative;

    @media (max-width: 768px) {
      flex-direction: column;
    }
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.five};
    `}
  `}
`

export const TextWrapper = styled.div`
  ${({theme}) => css`
    padding-right: ${theme.spacing.one};
  `}
`

export const ButtonWrapper = styled.div`
  ${({theme}) => css`
    flex-grow: 1;
    margin-top: ${theme.spacing.two};
    text-align: right;
  `}
`

export const StyledButton = styled(Button)`
  width: 100%;
  ${({theme}) => css`
    height: ${theme.spacing.five};
    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 325px;
    `}
  `}
`

export const StyledPill = styled.span`
  ${({theme}) => css`
    background-color: ${theme.colors.primary2_50};
    border-radius: ${theme.spacing.one};
    color: ${theme.colors.primary2};
    display: inline-block;
    font-weight: bold;
    margin-bottom: ${theme.spacing.two};
    margin-right: ${theme.spacing.one};
    padding: ${theme.spacing.one} ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.oneAndHalf} ${theme.spacing.two};
    `}
  `}
`

export const StyledClose = styled(Close)`
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      top: ${theme.spacing.three};
      right: ${theme.spacing.three};
    `}
  `}
`
